import { createRequire } from "module";

export type ClipboardModule = {
	setText: (text: string) => Promise<void>;
	hasImage: () => boolean;
	getImageBinary: () => Promise<Array<number>>;
};

const require = createRequire(import.meta.url);
let clipboard: ClipboardModule | null = null;
let moduleUnavailable = false;

const hasDisplay = process.platform !== "linux" || Boolean(process.env.DISPLAY || process.env.WAYLAND_DISPLAY);

if (!process.env.TERMUX_VERSION && hasDisplay) {
	try {
		clipboard = require("@elyracode/clipboard") as ClipboardModule;
	} catch {
		// npm silently skips optional dependencies that fail to install (e.g.
		// an update raced registry propagation), which would otherwise degrade
		// image paste to a silent no-op. Track it so the UI can say so.
		clipboard = null;
		moduleUnavailable = true;
	}
}

/** True when the native clipboard module was needed but could not be loaded. */
export const clipboardModuleUnavailable = moduleUnavailable;

export { clipboard };
